import React from "react";

// The Albetheine Eye — a custom occult mark blending an open eye, a
// triquetra-like Celtic motif and Lemurian rays. SVG only, no external assets.
export default function AlbetheineEye({ size = 120, className = "" }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 200 200"
      fill="none"
      className={className}
      aria-hidden="true"
    >
      <defs>
        <radialGradient id="iris" cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor="#e8c87a" />
          <stop offset="55%" stopColor="#c9a961" />
          <stop offset="100%" stopColor="#5a4623" />
        </radialGradient>
        <linearGradient id="goldline" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#e8c87a" />
          <stop offset="100%" stopColor="#8a7341" />
        </linearGradient>
      </defs>

      {/* Outer ring */}
      <circle
        cx="100"
        cy="100"
        r="92"
        stroke="url(#goldline)"
        strokeWidth="1"
        opacity="0.55"
      />
      <circle
        cx="100"
        cy="100"
        r="84"
        stroke="url(#goldline)"
        strokeWidth="0.7"
        opacity="0.4"
      />

      {/* 8-point rays (lemurian) */}
      {Array.from({ length: 16 }).map((_, i) => {
        const a = (i * Math.PI) / 8;
        const r1 = 60;
        const r2 = i % 2 === 0 ? 82 : 74;
        const x1 = 100 + Math.cos(a) * r1;
        const y1 = 100 + Math.sin(a) * r1;
        const x2 = 100 + Math.cos(a) * r2;
        const y2 = 100 + Math.sin(a) * r2;
        return (
          <line
            key={i}
            x1={x1}
            y1={y1}
            x2={x2}
            y2={y2}
            stroke="#c9a961"
            strokeWidth={i % 2 === 0 ? 1 : 0.6}
            opacity={i % 2 === 0 ? 0.85 : 0.55}
          />
        );
      })}

      {/* Eye almond */}
      <path
        d="M 30 100 Q 100 40 170 100 Q 100 160 30 100 Z"
        fill="#0a0a0c"
        stroke="url(#goldline)"
        strokeWidth="1.5"
      />

      {/* Iris */}
      <circle cx="100" cy="100" r="26" fill="url(#iris)" />
      {/* Pupil */}
      <circle cx="100" cy="100" r="10" fill="#0a0a0c" />
      {/* Catchlight */}
      <circle cx="95" cy="95" r="2.5" fill="#f1e6cf" opacity="0.9" />

      {/* Triquetra small marks above/below */}
      <g
        stroke="#c9a961"
        strokeWidth="0.9"
        fill="none"
        opacity="0.85"
      >
        <circle cx="100" cy="34" r="3.5" />
        <circle cx="100" cy="166" r="3.5" />
        <circle cx="18" cy="100" r="3" />
        <circle cx="182" cy="100" r="3" />
      </g>
    </svg>
  );
}
